import { render } from "./NewMessage.vue?vue&type=template&id=06088e42&scoped=true"
import script from "./NewMessage.vue?vue&type=script&lang=js"
export * from "./NewMessage.vue?vue&type=script&lang=js"

import "./NewMessage.vue?vue&type=style&index=0&id=06088e42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06088e42"

export default script